export const INTERNAL_EMAILS = [
  "albert@cinesis.ai",
  "loadfinder@cinesis.ai",
  "shashwat@cinesis.ai",
  "zoe@cinesis.ai",
  "awei001@berkeley.edu",
  "alvinl@berkeley.edu",
  "jacob@cinesis.ai",
  "azhar@cinesis.ai",
];
